var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-input-container",
    [
      _c("md-icon", { attrs: { "md-iconset": "fa fa-dollar-sign" } }),
      _c("label", [_vm._v("Price")]),
      _c("md-input", {
        attrs: { type: "number" },
        on: { input: _vm.onPriceUpdate },
        model: {
          value: _vm.price,
          callback: function($$v) {
            _vm.price = $$v
          },
          expression: "price"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f814a3d8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f814a3d8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/pricing/PriceInput.vue
// module id = 869
// module chunks = 0